import 'element-matches-polyfill';

export function getNextSibling( elem, selector ) {

	// Get the next sibling element
	let sibling = elem.nextElementSibling;

	// If there's no selector, return the first sibling
	if ( !selector ) return sibling;

	// If the sibling matches our selector, use it
	// If not, jump to the next sibling and continue the loop
	while ( sibling ) {
		if ( sibling.matches( selector ) ) return sibling;
		sibling = sibling.nextElementSibling
	}

};

export function getParent( elem, selector ) {

	let parent = elem.parentElement;

	if ( !selector ) return parent;

	while ( parent ) {
		if ( parent.matches( selector ) ) return parent;
		parent = parent.parentElement;
	}

}